import { Environment } from './environment.interface';

declare const require: any;

export const environment: Environment = {
  production: true,
  VERSION: require('../../package.json').version,
  apiUxUrl: 'https://cockpit-api.finzzle-groupe.com/v1/',
  authConfig: {
    loginUrl: 'https://reseau.prodemial.fr/cas/oauth2.0/authorize',
    logoutUrl: 'https://reseau.prodemial.fr/cas/logout',
    tokenUrl: 'https://reseau.prodemial.fr/cas/oauth2.0/token',
    clientId: 'ca468d05df.prod.prodemial',
    frontExpirationMinutes: 30
  },
  qlikConfig: 3,
  matomo: {
    url: 'https://omniumfinance.matomo.cloud/',
    siteId: 12
  },
  zendesk: {
    url: 'https://prodemial.zendesk.com/'
  },
  synapse: {
    apiKey: '9DTuXSgyA72y23D77x7rB3VA9VKwwMjgwq97L64r',
    clientName: 'Omnium_prod',
    categories: ['Centre d\'aide', 'Documents', 'Outils', 'Pages MyProdémial', 'Vidéos', 'Pages extranet Placement', 'Pages extranet Immobilier']
  },
  lienRedirectionB2S: '/contenu/188'
};

console.log(environment);